import React, { Component } from 'react';

export default function (ComposedComponent) {
  class NetworkDetector extends Component {
    state = {
      isDisconnected: false,
      slow : false
    }

    componentDidMount() {
      this.handleConnectionChange();
      window.addEventListener('online', this.handleConnectionChange);
      window.addEventListener('offline', this.handleConnectionChange);
    }

    // componentWillUnmount() {
    //   window.removeEventListener('online', this.handleConnectionChange);
    //   window.removeEventListener('offline', this.handleConnectionChange);
    // }


    handleConnectionChange = () => {
      const condition = navigator.onLine ? 'online' : 'offline';
      let time = new Date().getTime()
      // if (condition === 'online') {
      //   const webPing = setInterval(
      //     () => {
      //       fetch('//google.com', {
      //         mode: 'no-cors',
      //         })
      //       .then(() => {
      //         this.setState({ isDisconnected: false }, () => {
      //           let newTime = new Date().getTime()-time;
      //           if(newTime>2100){
      //             time = new Date().getTime() 
      //             this.setState({slow:true})
      //             console.log("wwwwqeqwerwr",newTime)
      //           }else {
      //             this.setState({slow:false})
      //             return clearInterval(webPing)

      //           }
      //         });
      //       }).catch(() => {
      //         return this.setState({ isDisconnected: true })
      //       })
      //     }, 2000);
      //   return;
      // } else {
      //   return this.setState({ isDisconnected: true });

      // }

    }

    render() {
      const { isDisconnected } = this.state;
      return (
        <div>
          { isDisconnected && (<div className="internet-error">
              <p>Internet connection lost</p>
            </div>)
          }
          <ComposedComponent props = {this.props} stateObj = {this.state} />
        </div>
      );
    }
  }

  return NetworkDetector;
}